<template>
  <v-row class="ma-0">
    <v-col cols="12" md="12">
      <ValidationObserver ref="validationObserver">
        <v-form>
          <!-- Mensaje informativo -->
          <div class="container_info_azul">
            <p>{{$t("¡Fideliza a tus clientes!, Configura cada cuantas ventas tus clientes van a recibir una oferta o promocion!")}}</p>
            <span>{{ $t("El texto que introduzca, será impreso en el ticket.") }}</span>
          </div>


          <!-- PROMOCION TICKET ACTIVO FIELD -->
          <v-row class="ma-0">
            <v-col cols="12" class="pa-0">
              <v-switch
                  v-model="configuracion_ticket.is_promocion_ticket"
                  :label="$t('Promoción ticket activo')"
              ></v-switch>
            </v-col>
          </v-row>
          <!-- FIN PROMOCION TICKET ACTIVO FIELD -->

          <div v-if="configuracion_ticket.is_promocion_ticket">
            <!-- TIPO TICKET PROMOCION FIELD -->
            <v-row class="ma-0 mt-3">
              <v-col cols="12" class="pa-0">
                <ValidationProvider rules="required"
                                    :name="$t('Imprimir tickets').toLowerCase()"
                                    v-slot="{ errors, classes }"
                >
                  <div class="control" :class="classes">

                    <v-select
                        hide-details
                        :label="$t('Tipo ticket promocíón')"
                        v-model="configuracion_ticket.tipo_ticket_promocion"
                        :items="data_form.tipos_tickets_promocion"
                        :no-data-text="$t('No hay datos')"
                        dense
                        outlined
                    ></v-select>
                  </div>
                  <span class="error--text">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- FIN TIPO TICKET PROMOCION FIELD -->


            <!-- CANTIDAD VENTAS PROMOCION FIELD -->
            <v-row class="ma-0 mt-3">
              <v-col cols="12" class="pa-0">
                <ValidationProvider rules="required"
                                    :name="$t('Número de ventas').toLowerCase()"
                                    v-slot="{ errors, classes }"
                >
                  <div class="control" :class="classes">

                    <v-select
                        hide-details
                        :label="$t('Número de ventas')"
                        v-model="configuracion_ticket.cantidad_ventas_promocion_ticket"
                        :items="data_form.tipos_cantidad_ventas_promocion_ticket"
                        :no-data-text="$t('No hay datos')"
                        dense
                        outlined
                    ></v-select>
                  </div>
                  <span class="error--text">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- FIN CANTIDAD VENTAS PROMOCION FIELD -->

            <!-- IMPORTE MINIMO VENTA FIELD -->
            <v-row class="ma-0 mt-3">
              <v-col cols="12" class="pa-0">
                <ValidationProvider rules="required"
                                    :name="$t('Importe mínimo de la venta').toLowerCase()"
                                    v-slot="{ errors, classes }"
                >
                  <div class="control" :class="classes">
                    <v-text-field
                        hide-details
                        v-model="configuracion_ticket.importe_minimo_promocion_ticket"
                        :label="$t('Importe mínimo de la venta')"
                        type="number"
                        :outlined="true"
                        :dense="true"
                    ></v-text-field>
                  </div>
                  <span class="error--text">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- FIN IMPORTE MINIMO VENTA FIELD -->

            <!-- TEXTO PROMOCIÓN FIELD -->
            <v-row class="ma-0 mt-3">
              <v-col cols="12" class="pa-0">
                <ValidationProvider rules="required|max:254"
                                    :name="$t('Texto de promoción').toLowerCase()"
                                    v-slot="{ errors, classes }"
                >
                  <div class="control" :class="classes">

                    <v-textarea
                        hide-details
                        v-model="configuracion_ticket.texto_promocion_ticket"
                        :label="$t('Texto de promoción')"
                        outlined
                        dense
                    />
                  </div>
                  <span class="error--text">{{ errors[0] }}</span>
                </ValidationProvider>
              </v-col>
            </v-row>
            <!-- FIN TEXTO PROMOCIÓN FIELD -->
          </div>
        </v-form>
      </ValidationObserver>
    </v-col>

    <!-- Boton de guardar datos -->
    <v-btn @click="save" color="primary" block small>
      <v-icon small>mdi-content-save</v-icon>
      <span class="ml-1">{{ $t('Guardar') }}</span>
    </v-btn>
  </v-row>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
  name: "PromocionTickets",

  data: () => ({
    CONSTANTS,
  }),

  methods: {
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid) {
        this.$emit('on_click_save')
      }

    },
  },

  props: {
    configuracion_ticket: {
      type: Object,
      required: true
    },
    centro: {
      type: Object,
      required: true
    },
    data_form: {
      type: Object,
      required: true
    },
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>

<style scoped>

</style>